<ng-template #thisModalForm role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="thisFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="thisFormSubmitAttempt()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
              <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
              <span [innerHtml]="progressInformation"></span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="exampleFieldName-field" class="form-label">Example Field Name</label>
            <input autocomplete="no-fill" type="text" id="exampleFieldName-field" class="form-control" placeholder="" formControlName="exampleFieldName" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['exampleFieldName'].errors }" />
            @if(formOfThis['exampleFieldName'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{exampleFieldNameMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="thisFormCancel()">Close</button>
        <button type="submit" [disabled]="!submitButtonEnabled" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
